import { injectable, inject } from 'inversify';
import type { IPlanRepository } from '@/domain/repositories/IPlanRepository';
import { Plan } from '@/domain/entities/Plan';
import { TYPES } from '@/di/tokens';

@injectable()
export class ListPlansAction {
  constructor(
    @inject(TYPES.IPlanRepository) private planRepository: IPlanRepository
  ) {}

  async execute(): Promise<Plan[]> {
    return await this.planRepository.getAll();
  }
}
